import { graphql } from 'gatsby';
import { I18nextContext, useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useContext } from 'react';

import HelpPageContent from '../components/HelpPageContent';
import Layout from '../components/Layout';
import Seo from '../components/Seo';

const HelpPage = (): JSX.Element => {
  const { language } = useContext(I18nextContext);
  const { t } = useTranslation('help');

  return (
    <Layout user="tenant">
      <Seo
        canonical={`/${language}/help`}
        hreflang={language}
        title="Zappyrent Help"
        description={t('pageDescription')}
        ogImageUrl={`${process.env.GATSBY_CDN_URL}/opengraph/zappyrent-logo-green-500x500.png`}
        ogImageHeight="500"
        ogImageWidth="500"
      />
      <HelpPageContent />
    </Layout>
  );
};

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

export default HelpPage;
